import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _counter = signal(0);

  readonly isLoading = computed(() => this._counter() > 0);

  show(): void {
    this._counter.update(c => c + 1);
  }

  hide(): void {
    this._counter.update(c => Math.max(0, c - 1));
  }
}
